import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginService } from '../login/shared/login.service';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttendanceStatusService {
  headers = new HttpHeaders({
    'Authorization': this.authenticate.getToken(),
    'Content-Type': 'application/json'
  });

  constructor(
    private https: HttpClient,
    private authenticate: LoginService,
  ) { }

  getAttendanceStatus(staffid: any, search: any[], group: string) {
    let params = new HttpParams();
    if (staffid) { params = params.append('staff_id', staffid); }
    if (search.length > 0) {  params = params.append('search', search.join(',')); }
    if (group) { params = params.append('group', group); }

    return this.https.get(`${environment.SERVER_URL}/attendance_status`, { headers: this.headers, params: params })
      .pipe(
        catchError(err => throwError(err))
      );
  }

  //FILO
  getAttendancePerBranch(): Observable<any>{
    let headers = new HttpHeaders({
      'Authorization': this.authenticate.getToken(),
      'Content-Type': 'application/json'
    });

    return this.https.get(`${environment.SERVER_URL}/attendance_status/filo`, { headers: headers })
      .pipe(
        catchError(err => throwError(err))
      );
  }

  downloadAttendanceStatus(from, to, staffid: any): Observable<Blob>  {
    let params = new HttpParams();
    params = params.append('staff_id', staffid);
    params = params.append('from', from);
    params = params.append('to', to);
    let headers = new HttpHeaders({
      'Authorization': this.authenticate.getToken(),
      'Content-Type': 'application/json'
    })

    return this.https.get(`${environment.SERVER_URL}/attendance_status/download`, { headers: headers, params: params, responseType: 'blob' })
      .pipe(
        catchError(err => throwError(err))
      );
  }
}
